import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faQuestionCircle,
    faTimesCircle,
    faCircle,
} from '@fortawesome/free-solid-svg-icons';

// Used to disable accordion toggle events firing withing that amount of milliseconds after initial event
const debounceTime = 250;
@Component({
    selector: 'pace-core-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
    public faChevronDown = faChevronDown;
    public faChevronRight = faChevronRight;
    public faTimesCircle = faTimesCircle;
    public faCheckCircle = faCheckCircle;
    public faQuestionCircle = faQuestionCircle;
    public faCircle = faCircle;

    private toggleTime = 0;

    @Input()
    public accordionOpened = false;

    @Input()
    public open = false;

    @Input()
    public accordionInvalid = false;

    @Input()
    public displayStatusIcon = true;

    @Input()
    public allowCollapse = true;

    @Input()
    public isUnknownStatusAllowed = true;

    @Input()
    public showDataAvailabilityStatus = false;

    @Input()
    public hasData = false;

    @Output()
    public openChanged = new EventEmitter<boolean>();

    public toggleAccordion(event: UIEvent): boolean {
        if (!this.allowCollapse && this.open) {
            return false;
        }

        const now = Date.now();

        if (now - this.toggleTime < debounceTime) {
            event.preventDefault();

            if (typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }

            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
            return false;
        }

        this.toggleTime = now;
        this.open = !this.open;
        this.openChanged.emit(this.open);
        this.accordionOpened = true;
        return true;
    }
}
